(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var SELECTOR = '[data-animate]';
    var ACTIVE_ATTR = 'data-animate-active';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.setAttribute(ACTIVE_ATTR, '');
      });
    }

    // Offset each staggered child's delay by its position among its animated siblings.
    function applyStagger() {
      document.querySelectorAll('[data-animate-stagger]').forEach(function (group) {
        var children = group.querySelectorAll(':scope > [data-animate]');
        children.forEach(function (child, i) {
          if (i === 0) return;
          var existing = child.style.getPropertyValue('--animate-delay') || '0ms';
          child.style.setProperty(
            '--animate-delay',
            'calc(' + existing + ' + (' + i + ' * var(--animate-stagger-step)))'
          );
        });
      });
    }

    function init() {
      applyStagger();

      var elements = document.querySelectorAll(SELECTOR);
      if (!elements.length) return;

      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute(ACTIVE_ATTR, '');
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    // Skip animation entirely in the theme editor -- merchants shouldn't see
    // permanently-hidden content while editing, and section reordering can
    // otherwise leave observers in a stale state.
    if (window.Shopify && Shopify.designMode) {
      revealAll();
    } else if (reduceMotion) {
      revealAll();
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-reveal instantly if a section is re-rendered by the editor (setting change, etc).
    document.addEventListener('shopify:section:load', revealAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
